import React from 'react'
import { Switch, Route } from 'react-router'

import { ORDERS_SENT } from '../config/routes'
import withMainLayout from '../layouts/Main/withMainLayout'

import OrderSentListPage from '../pages/OrderSent/List/OrderSentListPage'
import NewLabOrderContainer from '../pages/LabReports/New/NewLabOrderContainer'
import ReviewLabOrder from '../pages/LabReports/Review/ReviewLabOrder'

const OrderSentRoutes = ({ path, me, loggedIn }) => (
  <Route
    path={path}
    render={() => (
      <Switch>
        <Route
          exact
          path={ORDERS_SENT.base}
          render={() =>
            withMainLayout(OrderSentListPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          path={ORDERS_SENT.new}
          render={() =>
            withMainLayout(NewLabOrderContainer, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          exact
          path={ORDERS_SENT.review}
          render={() =>
            withMainLayout(ReviewLabOrder, {
              me,
              loggedIn,
            })
          }
        />
        {/* <Route
          exact
          path={ORDERS_SENT.review}
          render={() =>
            withMainLayout(ReviewLabOrder, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          exact
          path={ORDERS_SENT.view}
          render={() =>
            withMainLayout(LabReportViewEditPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          exact
          path={ORDERS_SENT.resultDetails}
          render={() =>
            withMainLayout(ResultDetails, {
              me,
              loggedIn,
            })
          }
        />
        <NotesRoutes
          path={match.path}
          parentPath={`:labReportId${NOTES.base}`}
          me={me}
          loggedIn={loggedIn}
          fallbackRouteComponent={LabReportListPage}
        /> */}
      </Switch>
    )}
  />
)

export default OrderSentRoutes
